<div class="personal-info">
  <section class="personal-info__section">
    <header class="personal-info__header">
      <div class="personal-info__header-copy">
        <h3 class="personal-info__title">
          {{ 'app.components.personalInfo.title' | translate }}
        </h3>
        <p class="personal-info__subtitle">
          {{ 'app.components.personalInfo.subTitle' | translate }}
        </p>
      </div>
    </header>

    <div class="personal-info__body">
      <div class="personal-info__fields">
        <div class="personal-info__field">
          <span class="personal-info__field-label">
            {{ 'app.components.personalInfo.fullName' | translate }}
          </span>
          <div class="personal-info__field-value">
            {{ user()?.personalData?.firstName }} {{ user()?.personalData?.lastName }}
          </div>
        </div>
        <div class="personal-info__field">
          <span class="personal-info__field-label">
            {{ 'app.components.personalInfo.email' | translate }}
          </span>
          <div class="personal-info__field-value">
            {{ user()?.personalData?.email }}
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="personal-info__section">
    <header class="personal-info__header">
      <div class="personal-info__header-copy">
        <h3 class="personal-info__title">
          {{ 'app.components.personalInfo.location' | translate }}
        </h3>
        <p class="personal-info__subtitle">
          {{ 'app.components.personalInfo.countryDescription' | translate }}
        </p>
      </div>
    </header>

    <div class="personal-info__body">
      <div class="personal-info__fields personal-info__fields--single">
        <div class="personal-info__field">
          <span class="personal-info__field-label">
            {{ 'app.components.personalInfo.country' | translate }}
          </span>
          <div class="personal-info__field-value">
            {{ user()?.personalData?.country }}
          </div>
        </div>
      </div>
    </div>
  </section>

  <app-parent-identity-section />

  <section class="personal-info__section">
    <header class="personal-info__header">
      <div class="personal-info__header-copy">
        <h3 class="personal-info__title">
          {{ 'app.components.personalInfo.profilePicture' | translate }}
        </h3>
        <p class="personal-info__subtitle">
          {{ 'app.components.personalInfo.profilePictureDescription' | translate }}
        </p>
      </div>
    </header>

    <div class="personal-info__body">
      <div class="personal-info__avatar-row">
        <div class="personal-info__avatar">
          @if (user()?.personalData?.avatar) {
            <img [src]="user()?.personalData?.avatar" alt="" />
          } @else {
            <span>{{ user()?.personalData | initials }}</span>
          }
        </div>

        <div class="personal-info__avatar-actions">
          <input
            type="file"
            #fileInput
            hidden
            accept="image/png, image/jpeg, image/jpg"
            (change)="fileChangeEvent($event)"
          />
          <app-parent-button
            variant="ghost"
            [disabled]="isUploading()"
            [loading]="isUploading()"
            (clicked)="fileInput.click()"
          >
            @if (!isUploading()) {
              {{ 'app.components.personalInfo.edit' | translate }}
            } @else {
              {{ 'app.components.personalInfo.uploading' | translate }}
            }
          </app-parent-button>
          <app-parent-button
            variant="icon"
            [attr.aria-label]="'app.components.personalInfo.deleteAvatar' | translate"
            (clicked)="deleteAvatar()"
          >
            <img src="/public/svgs/trash-red.svg" alt="" width="16" height="16" aria-hidden="true" />
          </app-parent-button>
        </div>
      </div>
    </div>
  </section>

  @if (showCropper()) {
    <div class="personal-info__cropper" role="dialog" aria-modal="true">
      <div class="personal-info__cropper-panel">
        <header class="personal-info__cropper-header">
          <div class="personal-info__header-copy">
            <h3 class="personal-info__title">
              {{ 'app.components.imageCropper.cropImage' | translate }}
            </h3>
          </div>
          <app-parent-button
            variant="icon"
            [attr.aria-label]="'app.components.imageCropper.cancel' | translate"
            (clicked)="closeCropper()"
          >
            <img src="/public/svgs/x-close.svg" alt="" width="16" height="16" aria-hidden="true" />
          </app-parent-button>
        </header>

        <div class="personal-info__cropper-body">
          @if (isImageLoading() && !hasImageError()) {
            <div class="personal-info__cropper-state">
              <span class="personal-info__spinner" aria-hidden="true"></span>
              <p>{{ 'app.components.imageCropper.loadingImage' | translate }}</p>
            </div>
          }

          @if (hasImageError()) {
            <div class="personal-info__cropper-state personal-info__cropper-state--error">
              <span class="personal-info__error-icon" aria-hidden="true"></span>
              @if (isFileSizeError()) {
                <h4>{{ 'app.components.imageCropper.fileSizeErrorTitle' | translate }}</h4>
                <p>{{ 'app.components.imageCropper.fileSizeErrorMessage' | translate }}</p>
              } @else {
                <h4>{{ 'app.components.imageCropper.loadErrorTitle' | translate }}</h4>
                <p>{{ 'app.components.imageCropper.loadErrorMessage' | translate }}</p>
              }
              <div class="personal-info__cropper-actions parent-dialog-actions">
                <app-parent-button variant="ghost" (clicked)="closeCropper()">
                  {{ 'app.components.imageCropper.cancel' | translate }}
                </app-parent-button>
                @if (!isFileSizeError()) {
                  <app-parent-button variant="primary" (clicked)="retryImageLoad()">
                    {{ 'app.components.imageCropper.retry' | translate }}
                  </app-parent-button>
                }
              </div>
            </div>
          }

          <image-cropper
            [imageChangedEvent]="imageChangedEvent"
            [maintainAspectRatio]="true"
            [aspectRatio]="1"
            format="png"
            (imageCropped)="imageCropped($event)"
            (imageLoaded)="imageLoaded($event)"
            (cropperReady)="cropperReady()"
            (loadImageFailed)="loadImageFailed()"
          />

          @if (isCropperReady()) {
            <div class="personal-info__cropper-actions parent-dialog-actions">
              <app-parent-button variant="ghost" (clicked)="closeCropper()">
                {{ 'app.components.imageCropper.cancel' | translate }}
              </app-parent-button>
              <app-parent-button
                variant="primary"
                [loading]="isUploading()"
                [disabled]="!croppedImage || isUploading()"
                (clicked)="saveCroppedImage()"
              >
                {{ 'app.components.imageCropper.crop' | translate }}
              </app-parent-button>
            </div>
          }
        </div>
      </div>
    </div>
  }
</div>
